'use client';

import { Button, HStack } from '@chakra-ui/react';
import { useTranslations } from 'next-intl';
import { useSelector } from 'react-redux';
import { IRedux } from '@/_store/types';
import { useState } from 'react';
import Auth from '@/_components/Auth';

interface BrandActionButtonsProps {
  onRestaurant: () => void;
  onCheckout: () => void;
  onClosePopover: () => void;
}

export default function BrandActionButtons({
  onRestaurant,
  onCheckout,
  onClosePopover,
}: BrandActionButtonsProps) {
  const t = useTranslations();
  const { user } = useSelector((state: IRedux) => state.auth);
  const [isAuthOpen, setIsAuthOpen] = useState(false);

  const handleRestaurantClick = () => {
    onRestaurant();
  };

  const handleCheckoutClick = () => {
    if (!user?.id) {
      onClosePopover();
      setIsAuthOpen(true);
      return;
    }

    onCheckout();
  };

  return (
    <>
      <HStack w='full' gap={2} mt='20px'>
        <Button
          variant='subtle'
          flex={1}
          rounded={12}
          size='md'
          onClick={handleRestaurantClick}
        >
          {t('in_restaurant')}
        </Button>
        <Button
          bg='primary'
          color='primary.text'
          rounded={12}
          flex={1}
          size='md'
          onClick={handleCheckoutClick}
          _hover={{ bg: 'primary.hover' }}
        >
          {t('checkout_order')}
        </Button>
      </HStack>
      <Auth
        open={isAuthOpen}
        onClose={() => setIsAuthOpen(false)}
        onLastConfirm={() => {
          setIsAuthOpen(false);
          onCheckout();
        }}
      />
    </>
  );
}
